import React from 'react';
export default function FetchingContent(props) {
  return (
    <div className="fetching-content">
      <div className="css-spinner" />
      <h3>Loading{ props.fetching && ` ${props.fetching}` }...</h3>
    </div>
  )
}



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/common/components/fetching-content.es6